

import Vue from 'vue'
import  Vant from 'vant';
import '@/styles/index.scss';
import 'vant/lib/index.css';


Vue.use(Vant);